import { hasPermission } from "../../config/permissions";

export function canAccessBi(user) {
  return hasPermission(user, "bi_reports") || hasPermission(user, "reports");
}
